/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

// Routes
import paths from './paths'

Vue.use(Router)
Vue.use(Meta, {
  keyName: 'metaInfo'
})

const router = new Router({
  mode: 'abstract',
  base: process.env.BASE_URL,
  routes: paths,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})
export default router
